var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "globalOverlay360" }, [
    _c(
      "button",
      {
        staticClass: "mz-button mz-button-close",
        attrs: { "aria-label": _vm.$translate("Ceres::Template.closeIcon") },
        on: { click: _vm.toggle },
      },
      [_vm._v("\n    ×\n  ")]
    ),
    _vm._v(" "),
    _vm.isSupported
      ? _c(
          "a",
          {
            staticClass: "Magic360",
            attrs: {
              "data-options":
                "filename: img{col}.jpg; columns:20; autospin-speed: 1800;",
            },
          },
          [_c("img", { attrs: { src: _vm.imagePath } })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }